import { Link } from "react-router-dom"
import './payment-history-header.css'
const PaymentHistoryHeader = ({ transactionId }) =>  {

    return(
        <div className="payment-history-header">
            <div className="payment-history-header__title">
              Transaction ID : {transactionId}
            </div>
            <div className="payment-history-header__btn">
                <Link to={"/agent/payments"} >
                    <button>Back</button>
                </Link>
            </div>
        </div>
    )
    
}
export default PaymentHistoryHeader